export class EntPersonellFilter {

  periodStart: string | null = null
  periodEnd: string | null = null
  governmentIds: number[] | null = null
  governmentAlias: string[] | null = null
  page: number;
  size: number;
  deleted: boolean;

  constructor(init?:Partial<EntPersonellFilter>) {
    this.periodStart = null;
    this.periodEnd = null;
    this.governmentIds = null;
    this.deleted = false;
    this.page = 1;
    this.size = 15;
    if(init){
      Object.assign(this, init)
    }
  }
}
